// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/mltraining/v1/ml_training.proto" (package "viam.app.mltraining.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MLTrainingService } from "./ml_training";
import type { ListSupportedContainersResponse } from "./ml_training";
import type { ListSupportedContainersRequest } from "./ml_training";
import type { GetTrainingJobLogsResponse } from "./ml_training";
import type { GetTrainingJobLogsRequest } from "./ml_training";
import type { DeleteCompletedTrainingJobResponse } from "./ml_training";
import type { DeleteCompletedTrainingJobRequest } from "./ml_training";
import type { CancelTrainingJobResponse } from "./ml_training";
import type { CancelTrainingJobRequest } from "./ml_training";
import type { ListTrainingJobsResponse } from "./ml_training";
import type { ListTrainingJobsRequest } from "./ml_training";
import type { GetTrainingJobResponse } from "./ml_training";
import type { GetTrainingJobRequest } from "./ml_training";
import type { SubmitCustomTrainingJobResponse } from "./ml_training";
import type { SubmitCustomTrainingJobRequest } from "./ml_training";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SubmitTrainingJobResponse } from "./ml_training";
import type { SubmitTrainingJobRequest } from "./ml_training";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service viam.app.mltraining.v1.MLTrainingService
 */
export interface IMLTrainingServiceClient {
    /**
     * SubmitTrainingJob submits a training job request.
     *
     * @generated from protobuf rpc: SubmitTrainingJob(viam.app.mltraining.v1.SubmitTrainingJobRequest) returns (viam.app.mltraining.v1.SubmitTrainingJobResponse);
     */
    submitTrainingJob(input: SubmitTrainingJobRequest, options?: RpcOptions): UnaryCall<SubmitTrainingJobRequest, SubmitTrainingJobResponse>;
    /**
     * SubmitCustomTrainingJob submits a custom training job request.
     *
     * @generated from protobuf rpc: SubmitCustomTrainingJob(viam.app.mltraining.v1.SubmitCustomTrainingJobRequest) returns (viam.app.mltraining.v1.SubmitCustomTrainingJobResponse);
     */
    submitCustomTrainingJob(input: SubmitCustomTrainingJobRequest, options?: RpcOptions): UnaryCall<SubmitCustomTrainingJobRequest, SubmitCustomTrainingJobResponse>;
    /**
     * GetTrainingJob retrieves a training job by its ID.
     *
     * @generated from protobuf rpc: GetTrainingJob(viam.app.mltraining.v1.GetTrainingJobRequest) returns (viam.app.mltraining.v1.GetTrainingJobResponse);
     */
    getTrainingJob(input: GetTrainingJobRequest, options?: RpcOptions): UnaryCall<GetTrainingJobRequest, GetTrainingJobResponse>;
    /**
     * ListTrainingJobs lists training jobs for a given organization ID and training status.
     *
     * @generated from protobuf rpc: ListTrainingJobs(viam.app.mltraining.v1.ListTrainingJobsRequest) returns (viam.app.mltraining.v1.ListTrainingJobsResponse);
     */
    listTrainingJobs(input: ListTrainingJobsRequest, options?: RpcOptions): UnaryCall<ListTrainingJobsRequest, ListTrainingJobsResponse>;
    /**
     * CancelTrainingJob cancels a training job that has not yet completed.
     *
     * @generated from protobuf rpc: CancelTrainingJob(viam.app.mltraining.v1.CancelTrainingJobRequest) returns (viam.app.mltraining.v1.CancelTrainingJobResponse);
     */
    cancelTrainingJob(input: CancelTrainingJobRequest, options?: RpcOptions): UnaryCall<CancelTrainingJobRequest, CancelTrainingJobResponse>;
    /**
     * DeleteCompletedTrainingJob removes a completed training job from the database, whether the job succeeded or failed.
     *
     * @generated from protobuf rpc: DeleteCompletedTrainingJob(viam.app.mltraining.v1.DeleteCompletedTrainingJobRequest) returns (viam.app.mltraining.v1.DeleteCompletedTrainingJobResponse);
     */
    deleteCompletedTrainingJob(input: DeleteCompletedTrainingJobRequest, options?: RpcOptions): UnaryCall<DeleteCompletedTrainingJobRequest, DeleteCompletedTrainingJobResponse>;
    /**
     * GetTrainingJobLogs gets the logs for a given custom training job.
     *
     * @generated from protobuf rpc: GetTrainingJobLogs(viam.app.mltraining.v1.GetTrainingJobLogsRequest) returns (viam.app.mltraining.v1.GetTrainingJobLogsResponse);
     */
    getTrainingJobLogs(input: GetTrainingJobLogsRequest, options?: RpcOptions): UnaryCall<GetTrainingJobLogsRequest, GetTrainingJobLogsResponse>;
    /**
     * ListSupportedContainers gets all the containers one can use for a custom training job.
     *
     * @generated from protobuf rpc: ListSupportedContainers(viam.app.mltraining.v1.ListSupportedContainersRequest) returns (viam.app.mltraining.v1.ListSupportedContainersResponse);
     */
    listSupportedContainers(input: ListSupportedContainersRequest, options?: RpcOptions): UnaryCall<ListSupportedContainersRequest, ListSupportedContainersResponse>;
}
/**
 * @generated from protobuf service viam.app.mltraining.v1.MLTrainingService
 */
export class MLTrainingServiceClient implements IMLTrainingServiceClient, ServiceInfo {
    typeName = MLTrainingService.typeName;
    methods = MLTrainingService.methods;
    options = MLTrainingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * SubmitTrainingJob submits a training job request.
     *
     * @generated from protobuf rpc: SubmitTrainingJob(viam.app.mltraining.v1.SubmitTrainingJobRequest) returns (viam.app.mltraining.v1.SubmitTrainingJobResponse);
     */
    submitTrainingJob(input: SubmitTrainingJobRequest, options?: RpcOptions): UnaryCall<SubmitTrainingJobRequest, SubmitTrainingJobResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubmitTrainingJobRequest, SubmitTrainingJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * SubmitCustomTrainingJob submits a custom training job request.
     *
     * @generated from protobuf rpc: SubmitCustomTrainingJob(viam.app.mltraining.v1.SubmitCustomTrainingJobRequest) returns (viam.app.mltraining.v1.SubmitCustomTrainingJobResponse);
     */
    submitCustomTrainingJob(input: SubmitCustomTrainingJobRequest, options?: RpcOptions): UnaryCall<SubmitCustomTrainingJobRequest, SubmitCustomTrainingJobResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubmitCustomTrainingJobRequest, SubmitCustomTrainingJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetTrainingJob retrieves a training job by its ID.
     *
     * @generated from protobuf rpc: GetTrainingJob(viam.app.mltraining.v1.GetTrainingJobRequest) returns (viam.app.mltraining.v1.GetTrainingJobResponse);
     */
    getTrainingJob(input: GetTrainingJobRequest, options?: RpcOptions): UnaryCall<GetTrainingJobRequest, GetTrainingJobResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetTrainingJobRequest, GetTrainingJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListTrainingJobs lists training jobs for a given organization ID and training status.
     *
     * @generated from protobuf rpc: ListTrainingJobs(viam.app.mltraining.v1.ListTrainingJobsRequest) returns (viam.app.mltraining.v1.ListTrainingJobsResponse);
     */
    listTrainingJobs(input: ListTrainingJobsRequest, options?: RpcOptions): UnaryCall<ListTrainingJobsRequest, ListTrainingJobsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListTrainingJobsRequest, ListTrainingJobsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CancelTrainingJob cancels a training job that has not yet completed.
     *
     * @generated from protobuf rpc: CancelTrainingJob(viam.app.mltraining.v1.CancelTrainingJobRequest) returns (viam.app.mltraining.v1.CancelTrainingJobResponse);
     */
    cancelTrainingJob(input: CancelTrainingJobRequest, options?: RpcOptions): UnaryCall<CancelTrainingJobRequest, CancelTrainingJobResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<CancelTrainingJobRequest, CancelTrainingJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteCompletedTrainingJob removes a completed training job from the database, whether the job succeeded or failed.
     *
     * @generated from protobuf rpc: DeleteCompletedTrainingJob(viam.app.mltraining.v1.DeleteCompletedTrainingJobRequest) returns (viam.app.mltraining.v1.DeleteCompletedTrainingJobResponse);
     */
    deleteCompletedTrainingJob(input: DeleteCompletedTrainingJobRequest, options?: RpcOptions): UnaryCall<DeleteCompletedTrainingJobRequest, DeleteCompletedTrainingJobResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteCompletedTrainingJobRequest, DeleteCompletedTrainingJobResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetTrainingJobLogs gets the logs for a given custom training job.
     *
     * @generated from protobuf rpc: GetTrainingJobLogs(viam.app.mltraining.v1.GetTrainingJobLogsRequest) returns (viam.app.mltraining.v1.GetTrainingJobLogsResponse);
     */
    getTrainingJobLogs(input: GetTrainingJobLogsRequest, options?: RpcOptions): UnaryCall<GetTrainingJobLogsRequest, GetTrainingJobLogsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetTrainingJobLogsRequest, GetTrainingJobLogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSupportedContainers gets all the containers one can use for a custom training job.
     *
     * @generated from protobuf rpc: ListSupportedContainers(viam.app.mltraining.v1.ListSupportedContainersRequest) returns (viam.app.mltraining.v1.ListSupportedContainersResponse);
     */
    listSupportedContainers(input: ListSupportedContainersRequest, options?: RpcOptions): UnaryCall<ListSupportedContainersRequest, ListSupportedContainersResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSupportedContainersRequest, ListSupportedContainersResponse>("unary", this._transport, method, opt, input);
    }
}
